import { safeGet, safeSet, safeRemove } from "../../../helpers/localStorage"

const isRodgDomain = () => window.location.host === "rideordieguide.com"

export const rodgPath = (page) => {
  const base = isRodgDomain() ? "" : "/rideordieguide"
  return page ? `${base}/${page}` : base || "/"
}

const RODG_PARKS_KEY = "rodg_park_selections"
const RODG_SELECTIONS_KEY = "rodg_selections"
const RODG_DONE_ITEMS_KEY = "rodg_done_items"
const RODG_DONE_SELECTIONS_KEY = "rodg_done_selections"
const RODG_WINNER_KEY = "rodg_winner"
const RODG_USER_COORDS_KEY = "rodg_user_coords"
const RODG_CUSTOM_COLORS_KEY = "rodg_custom_colors"

export const hasParks = () => {
  const data = safeGet(RODG_PARKS_KEY, null)
  return Array.isArray(data) && data.length > 0
}

export const loadParkIds = () => {
  const data = safeGet(RODG_PARKS_KEY, [])
  if (!Array.isArray(data)) return []
  return data.map((p) => p.id).filter(Boolean)
}

const loadSelectionsForKey = (key) => {
  const data = safeGet(key, [])
  if (!Array.isArray(data)) return []
  return data.map((item) => (typeof item === "string" ? { name: item, lat: null, lng: null } : item))
}

export const loadSelections = () => loadSelectionsForKey(RODG_SELECTIONS_KEY)

export const loadDoneSelections = () => loadSelectionsForKey(RODG_DONE_SELECTIONS_KEY)

export const loadWinner = () => safeGet(RODG_WINNER_KEY, null)

export const saveWinner = (name) => safeSet(RODG_WINNER_KEY, name)

export const clearWinner = () => safeRemove(RODG_WINNER_KEY)

export const markDone = (itemName, fallback = null) => {
  const selections = loadSelections()
  const fromSelections = selections.find((s) => s.name === itemName)
  const item =
    fromSelections || (fallback ? { name: itemName, lat: fallback.lat ?? null, lng: fallback.lng ?? null } : null)
  if (!item) return false
  if (fromSelections) {
    safeSet(
      RODG_SELECTIONS_KEY,
      selections.filter((s) => s.name !== itemName)
    )
  }
  const done = loadDoneSelections()
  if (!done.some((d) => d.name === itemName)) {
    done.push(item)
    safeSet(RODG_DONE_SELECTIONS_KEY, done)
  }
  const doneNames = safeGet(RODG_DONE_ITEMS_KEY, [])
  if (!doneNames.includes(itemName)) {
    doneNames.push(itemName)
    safeSet(RODG_DONE_ITEMS_KEY, doneNames)
  }
  safeRemove(RODG_WINNER_KEY)
  return true
}

export const loadUserCoords = () => safeGet(RODG_USER_COORDS_KEY, null)

export const loadCustomColors = () => safeGet(RODG_CUSTOM_COLORS_KEY, {})

export const saveCustomColors = (colors) => safeSet(RODG_CUSTOM_COLORS_KEY, colors)
